export { TCSCommunicationType } from './generated/TCSCommunicationType.js';